<template>
  <div class="text-start">
    <v-dialog v-model="isOpen" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on"> Show </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Tracking Number </v-card-title>

        <div class="pa-4">{{ trackingNumber }}</div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="isOpen = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TrackingNumberDialog',
  props: ['trackingNumber'],
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>
